import { v4 as uuidv4 } from 'uuid';
import { JsonFieldType } from '../../../types';
import { ComponentType, type IComponentSchema } from '../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Document Comparison',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.DocumentComparison,
    'x-component-props': {
      data: undefined,
      jsonData: undefined,
      modelInstanceId: undefined,
      height: 900,
      initialPaneCount: 1,
      addPaneText: 'Add pane',
      selectFilePlaceholder: 'Select a file',
      downloadButtonText: 'Download',
      previewButtonNotAvailableText: 'Preview not available for this file type',
      emptyStateText: 'Select a file to preview',
      visible: true,
    },
    'x-component-props-config': {
      data: { type: 'variable' },
      jsonData: { type: 'variable' },
    },
  };
};
